const MASTER = 'Master';
const ADDITIONAL_CLINICIAN = 'AdditionalClinician';
const OVERRIDDEN_CLINICIAN = 'OverriddenClinician';
const REVIEW = 'Review';
const RETROSPECTIVE_VISIT = 'RetrospectiveVisit';

const cardTypes = {
  MASTER,
  ADDITIONAL_CLINICIAN,
  OVERRIDDEN_CLINICIAN,
  REVIEW,
  RETROSPECTIVE_VISIT,
};

const careTypes = {
  onSite: 'OnSite',
  phoneCall: 'PhoneCall',
};

export { cardTypes, careTypes };
